<template>
    <div class="c-ratings-box">
        <div class="c-ratings-box__filter">
            <div class="c-ratings-filter">
                <div class="c-ratings-filter__item">
                    <button type="button" class="c-btn" :class="{'is-active': filter == 'all'}" @click="setFilter('all')">
                        <div class="sc-circle"></div>
                        <div class="sc-text">{{ $t('Ratings.General.all') }}</div>
                    </button>
                </div>

                <div class="c-ratings-filter__item">
                    <button type="button" class="c-btn" :class="{'is-active': filter == locale}" @click="setFilter(locale)">
                        <div class="sc-circle"></div>
                        <div class="sc-text">{{ $t(`Ratings.Only.${locale}`) }}</div>
                    </button>
                </div>

                <div class="c-ratings-filter__item js-dropdown-lang" v-if="filteredLanguages.length > 0">
                    <button type="button" class="c-btn" :class="{'is-active': filter != 'all' && filter != locale}" @click="showLangDropdown = !showLangDropdown">
                        <div class="sc-circle"></div>
                        <div class="sc-text">{{ filter != 'all' && filter != locale ? $t(`Ratings.Lang5.${filter}`) : $t('Ratings.General.others') }}</div>
                        <i aria-hidden="true" class="ico ico-caret-down"></i>
                    </button>

                    <div class="sc-dropdown" v-if="showLangDropdown">
                        <template v-for="language in filteredLanguages">
                            <button type="button" class="c-btn" :class="{'is-active': filter == language}" @click="setFilter(language)" :key="language">
                                <div class="sc-circle"></div>
                                <div class="sc-image"><img class="c-img" :src="`/img/flags/${language.split('_')[1].toLowerCase()}.svg`" /></div>
                                <div class="sc-text">{{ $t(`Ratings.Lang5.${language}`) }}</div>
                            </button>
                        </template>
                    </div>
                </div>
            </div>

            <div class="c-ratings-filter">
                <div class="c-ratings-filter__item is-sort js-dropdown-sort">
                    <button type="button" class="c-btn" @click="showSortDropdown = !showSortDropdown">
                        <i aria-hidden="true" class="ico ico-sort"></i>
                        <div class="sc-text">{{ sorts[sort] }}</div>
                        <i aria-hidden="true" class="ico ico-caret-down"></i>
                    </button>

                    <div class="sc-dropdown" v-if="showSortDropdown">
                        <template v-for="(srt, id) in sorts">
                            <button type="button" class="c-btn" :class="{'is-active': sort == srt}" @click="setSort(id)" :key="id">
                                <div class="sc-text">{{ srt }}</div>
                            </button>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <div class="c-ratings-box__list" :class="{'has-limit': showMore}">
            <div class="c-ratings-box__item" v-for="rating in filteredRatings" :key="rating.id">
                <div class="c-rating-item">
                    <div class="c-rating-item__head">
                        <div class="c-rating-item__stars js-stars" data-size="18" :data-stars="rating.rating">
                        </div>

                        <div class="c-rating-item__name">
                            {{ rating.customer_name }}
                        </div>

                        <div class="c-rating-item__country">
                            <img class="c-img" :src="`/img/flags/${rating.locale.split('_')[1].toLowerCase()}.svg`" />
                            {{ $t(`Ratings.Lang1.${rating.locale}`) }}
                        </div>

                        <div class="c-rating-item__date">
                            {{ formatDate(rating.created) }}
                        </div>
                    </div>

                    <div class="c-rating-item__text" v-if="rating.description">
                        {{ getRatingDescription(rating) }}
                    </div>

                    <div class="c-rating-item__translate" v-if="false && rating.locale != locale">
                        <button type="button" :title="$t('Ratings.General.translate')" class="c-link" @click.prevent="toggleTranslation(rating)" @mouseover="fetchTranslation(rating.id)">
                            <template v-if="isTranslated(rating.id)">{{ $t('Ratings.General.showOriginal') }}</template>
                            <template v-else>{{ $t('Ratings.General.translate') }}</template>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="c-ratings-box__more" v-if="showMore">
            <a href="#" :title="$t('Ratings.General.more')" class="c-link is-underlined" @click.prevent="moreRatings = true">
                <span>{{ $t('Ratings.General.more') }}</span>
            </a>
        </div>
    </div>
</template>

<script>
import client from "./../../../../vendor/rshop/frontend/assets/js/common/client";
import { CancelToken } from "axios";

export default {
    data() {
        return {
            isInitialized: false,
            fetchCancelToken: null,
            fetchingRatings: true,
            fetchingTranslations: {},
            ratingsTranslations: {},
            toggledTranslations: {},
            ratings: [],
            locales: [],
            sorts: [],
            productId: document.querySelector('.js-product-detail').getAttribute('data-id'),
            filter: 'all',
            locale: document.querySelector('.js-additional').getAttribute('data-locale'),
            sort: 0,
            showLangDropdown: false,
            showSortDropdown: false,
            moreRatings: false
        }
    },
    mounted() {
        document.addEventListener('click', this.checkDropdowns);
    },
    created() {
        this.fetchRatingsBox();
    },
    beforeDestroy () {
        document.removeEventListener('click',this.checkDropdowns);
    },
    methods: {
        cancelFetchRatingsBox() {
            if (this.fetchCancelToken) {
                this.fetchCancelToken.cancel()
            }

            this.fetchCancelToken = CancelToken.source()
        },
        fetchRatingsBox() {
            this.cancelFetchRatingsBox()
            this.fetchRatings()
        },
        fetchRatings() {
            this.fetchingRatings = true

            client
                .get(`/fetch-ratings/${this.productId}`, {
                    cancelToken: this.fetchCancelToken.token,
                })
                .then((response) => {
                    if (!response.data.status) {
                        return;
                    }

                    this.ratings = Object.values(response.data.data.ratings);
                    this.locales = Object.values(response.data.data.locales);
                    this.sorts = Object.values(response.data.data.sorts);
                    this.isInitialized = true;

                    this.$nextTick(() => {
                        this.buildStars()
                    })
                })
                .catch((error) => {})
                .then(() => {
                    this.fetchingRatings = false
                });
        },
        setFilter(locale) {
            this.filter = locale;
            this.showLangDropdown = false;
            this.moreRatings = false;

            this.$nextTick(() => {
                this.buildStars()
            })
        },
        setSort(sort) {
            this.sort = sort;
            this.showSortDropdown = false;

            this.$nextTick(() => {
                this.buildStars()
            })
        },
        checkDropdowns(event) {
            if (document.querySelector('.js-dropdown-lang') && !this.$el.querySelector('.js-dropdown-lang').contains(event.target)) {
                this.showLangDropdown = false;
            }

            if (document.querySelector('.js-dropdown-sort') && !this.$el.querySelector('.js-dropdown-sort').contains(event.target)) {
                this.showSortDropdown = false;
            }
        },
        buildStars() {
            $('.js-stars:not(.is-initialized)').each(function() {
                createStars($(this), {
                    readOnly: true,
                    starSize: parseInt($(this).attr('data-size')) || 16
                });
            });
        },
        formatDate(date) {
            const d = new Date(date);

            return `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()}`;
        },
        isFetchingTranslation(ratingId) {
            return this.fetchingTranslations[ratingId]
        },
        isTranslated(ratingId) {
            return this.toggledTranslations[ratingId]
        },
        fetchTranslation(ratingId) {
            if (this.isFetchingTranslation(ratingId) || this.ratingsTranslations[ratingId]) {
                return
            }

            this.$set(this.fetchingTranslations, ratingId, true)
            client
                .post(`/translate-rating`, {
                    ratingId: ratingId
                })
                .then((response) => {
                    if (!response.data.status) {
                        return;
                    }

                    this.$set(this.ratingsTranslations, ratingId, response.data.translation)
                })
                .catch((error) => {})
                .then(() => {
                    this.$delete(this.fetchingTranslations, ratingId)
                });
        },
        toggleTranslation(rating) {
            this.fetchTranslation(rating.id)
            this.$set(this.toggledTranslations, rating.id, !this.isTranslated(rating.id))
        },
        getRatingDescription(rating) {
            if (this.toggledTranslations[rating.id] && this.ratingsTranslations[rating.id]) {
                return this.ratingsTranslations[rating.id]
            }

            return rating.description
        },
    },
    computed: {
        filteredRatings() {
            let tmpRatings = this.ratings.filter(rating => rating.locale == this.filter || this.filter == 'all');

            if (this.sort == 0) {
                return tmpRatings.sort((a, b) => {
                    if (a.created < b.created) {
                        return 1;
                    }
                    else if (a.created > b.created) {
                        return -1;
                    }

                    return 0;
                });
            }
            else if (this.sort == 1) {
                return tmpRatings.sort((a, b) => {
                    if (a.created < b.created) {
                        return -1;
                    }
                    else if (a.created > b.created) {
                        return 1;
                    }

                    return 0;
                });
            }
            else if (this.sort == 2) {
                return tmpRatings.sort((a, b) => {
                    if (a.rating < b.rating) {
                        return 1;
                    }
                    else if (a.rating > b.rating) {
                        return -1;
                    }

                    return 0;
                });
            }
            else if (this.sort == 3) {
                return tmpRatings.sort((a, b) => {
                    if (a.rating < b.rating) {
                        return -1;
                    }
                    else if (a.rating > b.rating) {
                        return 1;
                    }

                    return 0;
                });
            }
        },
        filteredLanguages() {
            return this.locales.filter(locale => locale != this.locale);
        },
        showMore() {
            return this.filteredRatings.length > 5 && !this.moreRatings;
        }
    }
}
</script>